/**
 * 导出默认网路配置
 *
 * @author Shigq
 * @date 2020/12/4 11:17
 */
const network = {
	httpOptions: {
		baseURL: '/',
		timeout: 5 * 1000,
		contentType: 'application/json;charset=UTF-8'
	},
	httpCode: {
		//操作正常code，支持String、Array、int多种类型
		success: [200, '000000'],
		// system error
		serviceUnavailable: 503,
		// token timeout
		movedTemporarily: 302,
		// auth deny
		unauthorized: 401,
		// file not found
		notFound: 404,
	},
	gateway: {

	}
}
module.exports = network
